import { Button } from '@ophelos/ui/components/button';
import { Link } from 'react-router-dom';
import { useConfiguration } from '@/contexts/ConfigurationContext';
import { useCookieConsentSettings } from '@/contexts/CookieConsentContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { getLocalizedFooterLinks } from '@/lib/footer-links';
import { useTranslation } from '@/hooks/useTranslation';

export function Footer() {
  const { currentLanguage } = useLanguage();
  const { config } = useConfiguration();
  const { t } = useTranslation();
  const cookieSettings = useCookieConsentSettings();

  // Get localized footer links based on current language
  // The name field can be a simple string or a localized object
  // Uses config.ui.language as default locale (already in BCP 47 format like 'pt-PT')
  const footerLinks = getLocalizedFooterLinks(
    config.ui.termsLinks,
    currentLanguage,
    config.ui.language, // Use config language as default locale
  );

  return (
    <div className="w-full max-w-lg mx-auto flex flex-row flex-wrap items-center justify-center z-10 pb-4 relative">
      {footerLinks.map((link, index) => (
        <div key={`${link.name}-${link.url}-${index}`} className="flex items-center gap-1">
          <Button variant="linkMuted" size="sm" asChild>
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.name}
            </a>
          </Button>
          <span className="text-muted-foreground">•</span>
        </div>
      ))}
      <div className="flex items-center gap-1">
        <Button variant="linkMuted" size="sm" asChild>
          <Link to="/cookie-policy">{t('footer.cookiePolicy')}</Link>
        </Button>
        {cookieSettings && <span className="text-muted-foreground">•</span>}
      </div>
      {cookieSettings && (
        <Button variant="linkMuted" size="sm" onClick={cookieSettings.openSettings}>
          {t('footer.cookieSettings')}
        </Button>
      )}
    </div>
  );
}
